import { render, staticRenderFns } from "./PrintList.vue?vue&type=template&id=b71ccb96&scoped=true&"
import script from "./PrintList.vue?vue&type=script&lang=js&"
export * from "./PrintList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71ccb96",
  null
  
)

export default component.exports